import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { first, tap } from 'rxjs/operators';
import { AppState } from '../app-state';
import { areDocsLoaded } from './documents.selectors';
import { load, loadExternalDrive } from './documents.actions';
import { clearCache, loadProjectDocuments } from '../projectDocuments/projectDocuments.actions';
import { DriveComponent } from '../../pages/webapp/drive/drive.component';

@Injectable()
export class DocumentsResolver {
  constructor(private store: Store<AppState>) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store.pipe(
      select(areDocsLoaded),
      tap((_) => {
        this.store.dispatch(clearCache());
        const id = state.url.match(/projects\/(\d+)/)?.[1];
        const uuid = route.params.uuid;
        if (uuid) {
          this.store.dispatch(loadExternalDrive({ uuid }));
          return;
        }

        if (id) {
          DriveComponent.isProjectView.next(true);
          this.store.dispatch(loadProjectDocuments({ projectId: Number.parseInt(id, 10) }));
        } else {
          DriveComponent.isProjectView.next(false);
          // todo: consider re-adding the if statement
          // currently it is added because drive does not refresh if you navigate here from external drive
          this.store.dispatch(load());
        }
      }),
      first(),
    );
  }
}
